import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface OwnProps {
    triggerUrl: string;
    downloadUrl: string;
}

enum Status {
    preparing,
    processing,
    downloading,
    idle,
    error,
}

interface State {
    status: Status;
    progress: number | null;
}

export class Progress extends React.Component<OwnProps, State> {
    public state: State = {
        status: Status.preparing,
        progress: null,
    };

    private _isMounted: boolean = true;

    private async handle(response: {ready: boolean; progress: number}) {
        if (!this._isMounted) {
            return;
        }
        if (response.ready) {
            this.setState({
                status: Status.downloading,
                progress: 100,
            });
            setTimeout(() => {
                this.setState({
                    status: Status.idle,
                });
            }, 2500);
            window.location.href = this.props.downloadUrl;
        } else {
            this.setState({
                status: response.progress === 0 ? Status.preparing : Status.processing,
                progress: response.progress,
            });
            setTimeout(() => {
                this.poll();
            }, 500);
        }
    }

    private handleError() {
        if (this._isMounted) {
            this.setState({
                status: Status.error,
            });
            setTimeout(() => {
                this.setState({
                    status: Status.idle,
                });
            }, 2500);
        }
    }

    private async poll() {
        try {
            const result = await fetch(this.props.triggerUrl);
            if (result.status === 200) {
                await this.handle(await result.json());
            } else {
                this.handleError();
            }
        } catch (e) {
            this.handleError();
        }
    }

    public componentDidMount() {
        this._isMounted = true;
        this.poll();
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    private getText(): string {
        switch (this.state.status) {
            case Status.preparing:
                return 'Starting';
            case Status.processing:
                return 'Collecting';
            case Status.downloading:
                return 'Downloading';
            case Status.idle:
                return 'Download';
            case Status.error:
                return 'Error, try again';
        }
    }

    public render(): JSX.Element {
        return <span className="progress-bar-text">{this.getText()}</span>;
    }
}

(() => {
    function onClick(container: Element, triggerUrl: string, downloadUrl: string) {
        ReactDOM.render(
            <Progress key={new Date().getTime()} triggerUrl={triggerUrl} downloadUrl={downloadUrl} />,
            container,
        );
    }

    function initialize(button: Element) {
        const containerElementId = button.getAttribute('data-progress');
        if (containerElementId === null) {
            throw new Error('No container element defined for export button');
        }
        const containerElement = document.getElementById(containerElementId);
        if (containerElement === null) {
            throw new Error('Container element not mounted');
        }
        button.addEventListener('click', () => {
            onClick(containerElement, button.getAttribute('data-trigger')!, button.getAttribute('data-download')!);
        });
    }

    const elements = document.getElementsByClassName('export-btn');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elements.length; i++) {
        const button = elements[i];

        initialize(button);
    }
})();
